import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { queryKeys } from "@/lib/api/queryKeys";
import { API_ENDPOINTS } from "../config/constants";

/**
 * Query key factory for home dashboard
 */
export const homeDashboardQueryKeys = {
  all: ["home-dashboard"] as const,
  summary: () => [...homeDashboardQueryKeys.all, "summary"] as const,
};

/**
 * Hook to fetch dashboard summary data from /api/dashboard/summary
 *
 * Provides:
 * - Aggregated dashboard data for the home page
 * - Real-time updates via Mercure
 * - Automatic caching with 5-minute stale time
 * - Auto-refresh every 2 minutes
 */
export function useDashboardSummary() {
  // Mercure subscription lives in lib/config/mercureSubscriptions.ts
  // (topic: /api/dashboard/summary) so invalidation works app-wide.

  return useQuery({
    queryKey: homeDashboardQueryKeys.summary(),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.DASHBOARD_SUMMARY);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchInterval: 2 * 60 * 1000, // Refresh every 2 minutes
  });
}
